import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { FIELDS_CONFIG } from '../../fieldsConfig';

/**
 *  Хелпер createField для создания конфигурации одного поля.
 *  Чтобы модифицировать базовую конфигурацию можно передать parameters.
 *  Использовать createField и parameters при создании question следует, если выполняются все условия:
 *    1. Мы хотим использовать общее состояние одного поля формы.
 *       То есть name (EFormFieldsNames) таких полей должен быть одним и тем же.
 *    2. Если нужно добавить аналогичное поле, однако оно незначительно
 *       отличается каким-то свойством. Например заголовок у него будет другим.
 *
 *  Пример:
 *  const FIELDS: Array<EFormFieldsNames | TQuestionField> = [
 *    EFormFieldsNames.Name,
 *    ...
 *    createField(EFormFieldsNames.Files, {
 *      label: 'Загрузите фото паспорта',
 *      description: '',
 *      required: true,
 *    },
 *  ]
 *
 *  Здесь мы хотим использовать состояние поля files и не терять уже загруженные файлы.
 *  Возможно пользователь уже загружал какие-либо файлы, а после сменил тему обращения.
 *  Грустно заставлять пользователя грузить файлы по новой \__(-_-)__/
 *  Во всех других случаях нужно создавать отдельную конфигурацию для поля и описывать её в файле.
 */
export function createField(field) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, FIELDS_CONFIG[field].field), parameters);
}